import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PermissionsService } from './permissions.service';

@Injectable({
  providedIn: 'root'
})
export class QuestionsAndAnswersService {

  private apiUrl = 'https://exam.alarkkan.app/api/api/call';

  constructor(private http: HttpClient, private permissionsService: PermissionsService) { }

  getQuestionsBank(pageNumber: number, pageSize: number): Observable<any> {
    const body = {
      procedureName: 'sp_GetQuestionBank',
      params: {
        PageNumber: pageNumber,
        PageSize: pageSize
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  getAnswers(questionID: number): Observable<any> {
    const body = {
      procedureName: 'GetAnswersByQuestionID',
      params: {
        QuestionID: questionID
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
  
  GetQuestionByID(parentID: number): Observable<any> {
    const body = {
      procedureName: 'sp_GetQuestionByID',
      params: {
        QuestionID: parentID,
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
  
  getQuestionsByParentID(parentID: number , LangName: string): Observable<any> {
    const body = {
      procedureName: 'sp_GetQuestionsByParentID',
      params: {
        ParentQuestionID: parentID,
        LanguageName: LangName
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
  
  getTotalQuestionsNumber(): Observable<any> {
    const body = {
      procedureName: 'sp_GetTotalQuestionRecords',
      params: {}
    };
  
    return this.http.post<any>(this.apiUrl, body, {headers: { 'Content-Type': 'application/json' }});
  }

  addQuestionItem(questionItem: any, answerItems: any[]): Observable<any> {
    const body = {
      procedureName: 'sp_InsertQuestionWithAnswers',
      params: {
        UnitID: questionItem.UnitID,
        ParentQuestionID: questionItem.ParentQuestionID,
        QuestionText: questionItem.QuestionText,
        QuestionType: questionItem.QuestionType,
        Weightage: questionItem.Weightage,
        QuestionLevel: questionItem.QuestionLevel,
        VideoLink: questionItem.VideoLink,
        AudioLink: questionItem.AudioLink,
        ImageLink: questionItem.ImageLink,
        LanguageID: questionItem.LanguageID,
        // FormNo: questionItem.FormNo,
        IsActive: questionItem.IsActive,
        CreatedBy: this.permissionsService.getUserId(),


        Answers: JSON.stringify(answerItems.map((answer: any) => ({
          AnswerText: answer.AnswerText,
          IsCorrect: answer.IsCorrect ? 1 : 0,  
          ImageLink: answer.ImageLink,
          CreatedBy: this.permissionsService.getUserId() 
        })))
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }

  updateQuestionItem(questionItem: any, answerItems: any[]): Observable<any> {
    const body = {
      procedureName: 'sp_UpdateQuestionItem',
      params: {
        QuestionID: questionItem.QuestionID,
        Question: questionItem.Question,
        VideoLink: questionItem.VideoLink,
        ImageLink: questionItem.ImageLink,

        Answers: JSON.stringify(answerItems.map((answer: any) => ({
          AnswerID: answer.AnswerID,
          AnswerText: answer.AnswerText,
          IsCorrect: answer.IsCorrect,  
          ImageLink: answer.ImageLink, 
        })))
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }


  deleteQuestionItem(questionID: number): Observable<any> {
    const body = {
      procedureName: 'sp_DeleteQuestionWithAnswers',
      params: {
        QuestionID: questionID
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }


  uploadImage(type: string, file: File): Observable<any> {
    const myurl = 'https://exam.alarkkan.app/api/api/upload';
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    return this.http.post<any>(myurl, formData);
  }
  
  uploadVideo(type: string, file: File): Observable<any> {
    const myurl = 'https://exam.alarkkan.app/api/api/upload';
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    return this.http.post<any>(myurl, formData);
  }

  searchForItem(searchText: any): Observable<any> {
    const body = {
      procedureName: 'SearchQuestionsByTerm',
      params: {
        SearchTerm: searchText,
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }


  filteredQuestionBank(pageNumber: number, pageSize: number,courseName: string, unitName: string, questionType: string, questionLevel: string): Observable<any> {
    const body = {
      procedureName: 'sp_GetFilteredQuestionBank',
      params: {
        PageNumber: pageNumber,
        PageSize: pageSize,
        CourseName: courseName || null,
        UnitName: unitName || null,
        QuestionType: questionType || null,
        QuestionLevel: questionLevel || null
      }
    };
    return this.http.post<any>(this.apiUrl, body, { headers: { 'Content-Type': 'application/json' } });
  }
}
